import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PosService } from '../service/Sale/POS/pos.service';

@Injectable()
export class PathOneResolver  {
   

  constructor( private posService: PosService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Make the subject false
    let cashRegisterData = this.posService.getOption();
    let status = this.posService.getStatusToUpdate();

    console.log('Browser Refresh on Path1'+cashRegisterData.organiserDetailsName);

  }
}